import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class RuralFormalizationUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'rural-formalization'
  readonly name = 'Densidad de Propiedad Rural y Formalización'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
